import clsx from "clsx";

import "./ai-step-counter.scss";

// Pagination-style progress dots shown in the modal footer once the user is
// inside the flow. `current` is 0-based.
export const AiStepCounter = ({ current, total }) => (
  <div
    className="ai-step-counter"
    role="group"
    aria-label={`Step ${current + 1} of ${total}`}
  >
    {Array.from({ length: total }, (_, index) => (
      <span
        key={index}
        className={clsx(
          "ai-step-counter__dot",
          index === current && "ai-step-counter__dot--active"
        )}
      />
    ))}
  </div>
);
